<template>
  <div class="login">
    <div class="loginbbox formbox" v-show="!showRigist">
      <div class="logo">
        <img src="../assets/imgs/logo.png">
        <div>{{$t('logo')}}</div>
      </div>
      <el-form :model="ruleForm" ref="ruleForm" label-width="0px" class="demo-ruleForm">
        <el-form-item>
          <el-input prefix-icon="el-icon-user-solid" v-model="ruleForm.user" :placeholder="$t('index.input_login_name')"
            autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input prefix-icon="el-icon-lock" type="password" v-model="ruleForm.pswd"
            :placeholder="$t('index.input_login_password')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btnblac" type="primary" @click="submitLoginForm('ruleForm')">{{$t('login')}}</el-button>
        </el-form-item>
        <div class="flexbox fle-sb">
          <div class="btnn" @click="showRigist=true">{{$t('index.register')}}</div>
          <div class="btnn" @click="dialogVisible=true">{{$t('index.forget')}}</div>
        </div>
      </el-form>
    </div>
    <div class="registbox formbox" v-show="showRigist">
      <div class="flexbox  fle-sb linh4" v-if="!isApp">
        <div class="titw">{{$t('index.register2')}}</div>
        <div><span class="colob btnn" @click="showRigist=false">{{$t('index.login_now')}}</span></div>
      </div>
      <div v-if="isApp" class="registit">
        <div @click="showRigist=false" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
        {{$t('index.register2')}}
      </div>
      <el-form :model="regForm" :rules="rules" ref="regForm" label-width="0px" class="demo-ruleForm">
        <el-form-item prop="username">
          <el-input prefix-icon="el-icon-user-solid" type="text" v-model="regForm.username"
            :placeholder="$t('index.register_login_name')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input prefix-icon="el-icon-message" type="text" v-model="regForm.email"
            :placeholder="$t('index.register_email')" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item prop="countryCode">
          <el-select v-model="regForm.countryCode" class="selebox" allow-create filterable clearable
            :placeholder="$t('index.register_country_code')">
            <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
            <el-option v-for="item in country_codes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-input class="country_code" v-model="regForm.countryCode" clearable></el-input> -->
          <!-- <el-input prefix-icon="el-icon-date" type="password" v-model="ruleForm.checkPass" placeholder="请选择您的国家代码" autocomplete="off"></el-input> -->
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input prefix-icon="el-icon-mobile" type="number" v-model="regForm.mobile"
            :placeholder="$t('index.register_mobile')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input prefix-icon="el-icon-lock" type="password" v-model="regForm.password"
            :placeholder="$t('index.register_login_password')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="checkPassword">
          <el-input prefix-icon="el-icon-lock" type="password" v-model="regForm.checkPassword"
            :placeholder="$t('index.register_login_password_again')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="payPassword">
          <el-input prefix-icon="el-icon-key" type="password" v-model="regForm.payPassword"
            :placeholder="$t('index.register_trade_key')" autocomplete="off" v-on:click.native="showAlert"></el-input>
        </el-form-item>
        <el-form-item prop="checkPayPassword">
          <el-input prefix-icon="el-icon-key" type="password" v-model="regForm.checkPayPassword"
            :placeholder="$t('index.register_trade_key_again')" autocomplete="off"></el-input>
        </el-form-item>
        <div class="tip colorgray">{{$t('index.register_tip')}}</div>
        <el-form-item>
          <el-button class="btnblac" type="primary" @click="submitRegForm('regForm')">{{$t('index.submit')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :title="$t('index.forget')" :visible.sync="dialogVisible" width="30%">
      <span><i class="el-icon-warning"></i>{{$t('index.forget2')}}{{customer_service_email}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{$t('account.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // @ is an alias to /src
  import {
    getInfo,
    login,
    register,
    confirm
  } from '@/api/login.js'
  import {
    setToken
  } from '@/utils/auth'

  export default {
    name: 'login_box',
    data() {
      var checkUser = (rule, value, callback) => {
        var arr = new Array();
        arr = value.split(" ");
        if (value.trim() == "") {
          //this.$message.error('请输入用户名');
          callback(new Error(this.$t('index.register_input_login_name')));
        } else if (value.trim().length < 6) {
          callback(new Error(this.$t('index.register_input_login_name_error')));
        } else if (arr.length != 1) {
          callback(new Error(this.$t('index.register_input_login_name_error2')));
        } else {
          callback();
        }
      };
      var checkEmail = (rule, value, callback) => {
        if (value.trim() == "") {
          //this.$message.error('邮箱不能为空');
          callback(new Error(this.$t('index.register_input_email')));
        } else if (value.indexOf("@") == -1 || value.indexOf(".") == -1) {
          //this.$message.error('邮箱格式不正确');
          callback(new Error(this.$t('index.register_input_right_email')));
        } else {
          callback();
        }
      };
      var validateCountryCode = (rule, value, callback) => {
        if (value == "") {
          //this.$message.error('请输入密码');
          callback(new Error(this.$t('index.register_input_country_code')));
        } else {
          callback();
        }
      };
      var checkMobile = (rule, value, callback) => {
        //const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
        if (value.trim() == "") {
          callback(new Error(this.$t('index.register_input_mobile')));
        } else {
          callback()
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value.trim() == "") {
          //this.$message.error('请输入密码');
          callback(new Error(this.$t('index.register_input_login_password')));
        } else if (value.trim().length < 6) {
          callback(new Error(this.$t('index.register_input_login_password_error')));
        } else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t('index.register_input_login_password_again')));
        } else if (value !== this.regForm.password) {
          callback(new Error(this.$t('index.register_input_login_password_different')));
        } else {
          callback();
        }
      };
      var validatePayPass = (rule, value, callback) => {
        if (value.trim() == "") {
          //this.$message.error('请输入密码');
          callback(new Error(this.$t('index.register_input_trade_key')));
        } else if (value.trim().length < 6) {
          callback(new Error(this.$t('index.register_input_trade_key_error')));
        } else {
          callback();
        }
      };
      var validatePayPass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t('index.register_input_trade_key_again')));
        } else if (value !== this.regForm.payPassword) {
          callback(new Error(this.$t('index.register_input_trade_key_different')));
        } else {
          callback();
        }
      };
      return {
        showTips: false,
        showRigist: false,
        dialogVisible: false,
        ruleForm: {
          user: '',
          pswd: '',
        },

        country_codes: [],
        regForm: {
          username: "",
          email: "",
          mobile: "",
          countryCode: "",
          password: "",
          checkPassword: "",
          payPassword: "",
          checkPayPassword: ""
        },
        customer_service_email: "",
        rules: {
          username: [{
            validator: checkUser,
            trigger: "blur"
          }],
          email: [{
            validator: checkEmail,
            trigger: "blur"
          }],
          countryCode: [{
            validator: validateCountryCode,
            trigger: "blur"
          }],
          mobile: [{
            validator: checkMobile,
            trigger: "blur"
          }],
          password: [{
            validator: validatePass,
            trigger: "blur"
          }],
          checkPassword: [{
            validator: validatePass2,
            trigger: "blur"
          }],
          payPassword: [{
            validator: validatePayPass,
            trigger: "blur"
          }],
          checkPayPassword: [{
            validator: validatePayPass2,
            trigger: "blur"
          }]

        }
      }

    },
    computed: {
      isApp() {
        return document.documentElement.clientWidth < 800 ? true : false
      },
    },
    mounted() {
      getInfo().then(res => {
        if (res.code == 1) {
          this.customer_service_email = res.data.customer_service_email;
          this.country_codes = res.data.country_codes;
        }
      }).catch(_ => {

      });
      setToken("")
    },
    methods: {
      isApp2() {
        return document.documentElement.clientWidth < 800 ? true : false
      },
      submitLoginForm() {
        if (this.ruleForm.user == "") {
          this.$message.error(this.$t('index.input_login_name2'));
          return false
        }
        if (this.ruleForm.pswd == "") {
          this.$message.error(this.$t('index.input_login_password2'));
          return false
        }
        login(this.ruleForm.user, this.ruleForm.pswd).then(res => {
          if (res.code == 1) {
            let that = this
            setToken(res.data.token);
            this.$emit('change_bread', this.ruleForm.user)
            this.$message.success(res.msg)
            setTimeout(function() {
              if (that.isApp2()) {

                that.$router.replace('/home/accountApp')
              } else {
                that.$router.replace('/home/account')

              }
            }, 1000);
          } else {
            this.$message.error(res.msg)
          }
          //localStorage.setItem('token', res.data.token);
        }).catch(_ => {

        });
      },
      showAlert() {
        if (this.showTips == false) {
          // 把写的提示信心需要换行的地方分成数组 confirmText
          const confirmText = [this.$t('index.register_tip')]
          const newDatas = []
          const h = this.$createElement
          for (const i in confirmText) {
            newDatas.push(h('p', null, confirmText[i]))
          }
          this.$confirm(
            'Tips', {
              title: 'Tips',
              message: h('div', null, newDatas),
              showCancelButton: true,
              confirmButtonText: this.$t('account.trader_confirm'),
              cancelButtonText: this.$t('account.trader_cancel'),
              customClass: 'message-logout',
              type: 'warning'
            }).then((status) => {
            console.log(status);
          }).catch((status) => {
            if (status == 'cancel') {
              //取消想干啥
              console.log(status);

            }
          })
          this.showTips = true;
        }

      },
      submitRegForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            register(this.regForm).then(res => {
              if (res.code == 1) {
                this.$message.success(res.msg)
                this.showRigist = false;
              } else {
                this.$message.error(res.msg)
              }
            }).catch(_ => {

            });
          } else {
            console.log("注册失败");
            return false;
          }
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
  .formbox {
    padding: 40px 40px;
    margin: 120px auto;
    width: 600px;
    box-sizing: border-box;
    border-radius: 10px;
    background: #fefefe;

    .btnblac {
      background: #000;
      border: 0px;
      line-height: 36px;
      width: 100%;
    }

    .logo {
      font-size: 22px;
      line-height: 40px;
      margin-bottom: 20px;
      font-weight: bold;

      img {
        width: 140px;
        height: 140px;
      }
    }

    .titw {
      font-size: 18px;
      font-weight: bold;
    }

    .tip {
      padding-bottom: 10px;
    }

    .linh4 {
      line-height: 40px;
    }

    .colob {
      color: rgb(30, 137, 187);
    }

    .colorgray {
      color: #c5c5c5;
    }

    .el-select {
      width: 100%;
    }

    /* .el-form-item{
      position: relative;
    }
    .el-form-item .country_code .el-input{
      position: absolute;
      top: 1px;
      left: 25px;
      width: 150px;
    }
    .el-form-item .country_code .el-input input{
      border: none;
      height: 34px;
      line-height: 34px;
      padding: 0 15px;
    } */
  }
</style>
<style>
  @media (max-width: 730px) {
    .message-logout {
      width: 92% !important;
    }
  }
</style>
